import { FunctionComponent, useRef, MutableRefObject, useState, useEffect, SyntheticEvent, } from 'react';
import SelectButton from '@media-ui/core/src/components/SelectButton';
import classnames from 'classnames';
import { useFormContext } from 'react-hook-form';
import * as s from './PetsSelect.css';
import { PetsSelectProps, PetsSelectOption } from './PetsSelect.types';
import FormField from '../FormField';
const getDefaultValue = (array: PetsSelectProps['options'], value: string): PetsSelectOption | undefined => array.find((obj) => obj.value == value);
const PetsSelect: FunctionComponent<PetsSelectProps> = ({ label, placeholder, options, withSearch, alwaysShowAllOptions, name, required, dataQa, ...props }) => {
    const inputRef = useRef() as MutableRefObject<HTMLInputElement>;
    const rootRef = useRef() as MutableRefObject<HTMLDivElement>;
    const [search, setSearch] = useState<string>('');
    const { setValue, getValues } = useFormContext();
    const defaultValue = getDefaultValue(options, getValues(name) || props.defaultValue);
    const [option, setOption] = useState(defaultValue);
    useEffect(() => setValue(name, defaultValue?.value), []);
    const outsideClickHandler = (): void => {
        props.handleSelectState(true);
    };
    const insideClickHandler = (e: SyntheticEvent): void => {
        e.nativeEvent.stopImmediatePropagation();
        props.handleSelectState(props.active);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    useEffect(() => {
        document.addEventListener('click', outsideClickHandler);
        return (): void => {
            document.removeEventListener('click', outsideClickHandler);
        };
    }, []);
    const rootRefCurr = rootRef.current;
    const optionLabels = options
        .filter((option) => option && option.label)
        .map((option) => option.label.toLowerCase());
    let dropdownStyle = {};
    if (rootRefCurr) {
        dropdownStyle = {
            top: rootRefCurr.offsetTop + rootRefCurr.offsetHeight + 4,
            maxWidth: rootRefCurr.offsetWidth,
        };
    }
    return (<FormField overrideClassname={classnames(s.root, { [s.active]: props.active })} required={required} label={label} name={name}>
      <div ref={rootRef} onClickCapture={insideClickHandler} className={s.button} data-qa={dataQa}>
        <SelectButton isActive={props.active} isDisabled={false}>
          {withSearch ? (<input ref={inputRef} className={s.input} type="text" placeholder={placeholder} value={search || (option && option.label)} onChange={(e): void => {
                if (option)
                    setOption(undefined);
                setSearch(e.target.value);
            }}/>) : ((option && option.label) || placeholder)}
        </SelectButton>
      </div>
      {props.active && (<div style={dropdownStyle} className={s.dropdown}>
          {options
                .filter((item) => {
                const lowerOptionLabel = (option && option.label ? option.label : search).toLowerCase();
                if (withSearch &&
                    !(alwaysShowAllOptions &&
                        optionLabels.includes(lowerOptionLabel))) {
                    return item.label.toLowerCase().startsWith(lowerOptionLabel);
                }
                return true;
            })
                .map((item) => (<div onClick={(): void => {
                    if (search)
                        setSearch('');
                    if (inputRef.current)
                        inputRef.current.blur();
                    setOption(item);
                    setValue(name, item.value);
                    props.handleSelectState(true);
                }} className={s.dropdownItem} key={item.label}>
                {item.label}
              </div>))}
        </div>)}
    </FormField>);
};
export default PetsSelect;
